var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTabbarAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_tabbar_assets") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-154, -17)",
    stroke: "#0E1C39",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(157, 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57894737,7.57894737 L15.4210526,7.57894737 C15.9733374,7.57894737 16.4210526,8.02666262 16.4210526,8.57894737 L16.4210526,15.4210526 C16.4210526,15.9733374 15.9733374,16.4210526 15.4210526,16.4210526 L8.57894737,16.4210526 C8.02666262,16.4210526 7.57894737,15.9733374 7.57894737,15.4210526 L7.57894737,8.57894737 C7.57894737,8.02666262 8.02666262,7.57894737 8.57894737,7.57894737 Z",
    id: "\\u77E9\\u5F62",
    transform: "translate(12, 12) rotate(45) translate(-12, -12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 6.20420575,
    id: "\\u8DEF\\u5F84-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17.6842105,
    x2: 12,
    y2: 23.8884163,
    id: "\\u8DEF\\u5F84-8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTabbarAssets);
export default __webpack_public_path__ + "static/media/light_tabbar_assets.28f2573c80b9fe8361101b6294c2f4af.svg";
export { ForwardRef as ReactComponent };